export default "/_next/static/images/cab7b0889d4985da6b0d8728005f59fb.jpg";